export default __webpack_public_path__ + "static/media/studying.b40faf4d.gif";